import { useLayoutEffect, useMemo } from 'react';
import { ReactRenderStorage } from '../extensions';
import { logger } from '../logger';
import { EditorImpl } from './Editor';
import { BundlePreset } from './wysiwyg-preset';
export function useYfmEditor(props, deps = []) {
    const editor = useMemo(() => {
        const renderStorage = new ReactRenderStorage();
        const extensions = (builder) => {
            builder.use(BundlePreset, Object.assign(Object.assign({}, props.extensionOptions), { reactRenderer: renderStorage, onCancel: () => {
                    editor.emit('cancel', null);
                    return true;
                }, onSubmit: () => {
                    editor.emit('submit', null);
                    return true;
                }, mdBreaks: props.breaks, fileUploadHandler: props.fileUploadHandler, needToSetDimensionsForUploadedImages: props.needToSetDimensionsForUploadedImages }));
            if (props.extraExtensions) {
                builder.use(props.extraExtensions, props.extensionOptions);
            }
        };
        return new EditorImpl(Object.assign(Object.assign({}, props), { extensions, renderStorage }));
    }, deps.concat(props.allowHTML, props.linkify, props.linkifyTlds, props.breaks, props.splitMode, props.needToSetDimensionsForUploadedImages));
    useLayoutEffect(() => {
        function onToolbarAction({ editorType, id }) {
            logger.action({ mode: editorType, source: 'toolbar', action: id });
        }
        editor.on('toolbar-action', onToolbarAction);
        return () => {
            editor.off('toolbar-action', onToolbarAction);
            editor.destroy();
        };
    }, [editor]);
    return editor;
}
